import { atom } from "jotai";
import { emitZslExecutionErrorEventSetter } from "../events";
import { createNotificationSetter } from "../notifications/createNotificationSetter";
import { ZSL } from "../types";
import { zslExecutionFailedErrorMsgAtom } from "./zslExecutionFailedErrorMsgAtom";
import { showAIStreamCreateModalAtom } from "./showAIStreamCreateModalAtom";
import { isAiPageAtom } from "./isAiPageAtom";
import { isTemplatePageAtom } from "./isTemplatePageAtom";

type ZSLWithoutCanvases = Omit<ZSL, "canvases">;

type Params = {
  error: unknown;
  statusCode: number;
  prompt: string;
  zsl: ZSL | ZSLWithoutCanvases;
};

export const handleZslExecutionErrorSetter = atom(
  null,
  (get, set, { error, statusCode, prompt, zsl }: Params) => {
    const errorMessage =
      error instanceof Error
        ? error.message
        : isErrorObject(error)
          ? error.error
          : JSON.stringify(error);

    set(zslExecutionFailedErrorMsgAtom, errorMessage);
    if (prompt) {
      set(showAIStreamCreateModalAtom, true);
    } else {
      set(createNotificationSetter, {
        type: "error",
        message: errorMessage,
      });
    }

    const isAiPage = get(isAiPageAtom);
    const isTemplatePage = get(isTemplatePageAtom);

    set(emitZslExecutionErrorEventSetter, {
      prompt,
      zsl: JSON.stringify(zsl),
      status_code: statusCode,
      error_message: errorMessage,
      is_ai_page: isAiPage,
      is_template_page: isTemplatePage,
    });
  },
);

handleZslExecutionErrorSetter.debugLabel = "handleZslExecutionErrorSetter";

// Type guard for error object shape
function isErrorObject(value: unknown): value is { error: string } {
  return typeof value === "object" && value !== null && "error" in value;
}
